module.exports = __webpack_public_path__ + "img/skill_level_9_svg.e6c73405.svg";